import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
import EventBus from '@/plugins/EventBus'
import { Recebimento, ModalRecebimento, IRequestMessage, RecebimentoItem, ProfissionalExecutante, RecebimentoFiltro, RecebimentoPaciente, NovoProcedimento, RecebimentoItens, DataTablePagination } from '@/types/_'
import Apis from '@/Apis/_'
import moment from 'moment'
import { timeout } from '@/utils/common'
import { cpf } from 'cpf-cnpj-validator'

type FontePagadoraRecebimento = {
  fontePagadoraId: string,
  fontePagadoraNome: string,
}

type RelatorioRecebimento = {
  id: string,
  nome: string,
}

@Module({ namespaced: true, name: 'RecebimentoStore' })
export default class RecebimentoStore extends VuexModule {
  public requestMessage: IRequestMessage = {
    avancar: {
      text: 'Carregando...',
    },
    continuarDepois: {
      text: 'Enviando...',
    },
    init: {
      text: 'Carregando...',
    },
    status: true,
    deleteMessage: 'Deletando...',
    post: 'Enviando...',
    update: 'Atualizando...',
    messageFinish: 'Solicitação enviada com sucesso!',
    errorApi: 'Houve um erro no envio dos dados.',
    errorUpload: '',
    search: 'Buscando...',
  }

  modalRecebimento: ModalRecebimento = {
    detalhes: false,
    filtro: false,
  }

  recebimentoDefault: Recebimento = {
    contratoId: '',
    dataRecebimento: '',
    fontePagadora: '',
    fontePagadoraId: '',
    nomeArquivoOriginal: '',
    grupoRepasseNome: '',
    descontos: [],
    notasFiscais: [],
    acoes: {
      atualizar: false,
    },
    id: '',
    numeroRepasse: '',
    numeroPedido: '',
    prestador: '',
    previsaoRecebimento: '',
    valorBruto: 0,
  }

  private paginacaoDefault: DataTablePagination = {
    descending: false,
    page: 1,
    rowsPerPage: 5,
    sortBy: null,
    totalItems: 0,
    rowsPerPageItems: [5, 10, 20, 25],
  }

  public recebimento: Recebimento = { ...this.recebimentoDefault }
  public valoresCalculados: any[] = []
  public valorLiquido: string = ''
  public situacaoRecebimento: string = ''
  public fontePagadoraSelected: any[] = []
  public anoMesReferenciaSelected: string[] = []
  public dataInicio: string = ''
  public dataFim: string = ''
  public anoMesReferenciaDeSelected: string = ''
  public anoMesReferenciaAteSelected: string = ''
  public modalCadastroEmpresaMedicaResponsavel: boolean = false
  public modalGestores: boolean = false
  public modalAddGestores: boolean = false
  public contratoGestores: any[] = []
  public contratoId: string = ''
  public dadosAddGestor: any = {}
  public gestorIdResponse: string = ''
  public dadosContratoEGestores: any[] = []
  public fontePagadoraIdContrato: string = ''
  public selectedPrestador: any = ''
  public selectedProfissional: any = ''
  public tabelaPrecoId: any = ''
  public idTabelaProfissionais: any = ''
  public modalTabelaPrestador: boolean = false
  public modalTabelaProfissional: boolean = false
  public modalTabelaOperadora: boolean = false
  public modalAddTabelaPrestador: boolean = false
  public modalAddTabelaProfissional: boolean = false
  public modalAddTabelaOperadora: boolean = false
  public tabelaPrestadores: any[] = []
  public profissionais: any[] = []
  public tabelaProfissionais: any[] = []
  public tabelaProfissionaisById: any[] = []
  public operadorasList: any[] = []
  public selectedOperadora: any = ''
  public tabelaOperadoras: any[] = []
  public prestadoresRepasse: any = []
  public prestadores: any = []
  public modalDadosNF: boolean = false
  public nfSelected: any = {}
  public numeroNota: string = ''
  public valorNotaFiscal: string = ''
  public paginacaoTabelaPrestadores: DataTablePagination = { ...this.paginacaoDefault }

  recebimentoFiltroDefault: RecebimentoFiltro = {
    pagina: 1,
    contratoId: '',
    prestadorRecebimentoId: '',
    numeroAtendimento: '',
    paciente: '',
    procedimento: '',
    profissionalExecutante: '',
    selecionarPeriodo: 'false',
    dataRealizacaoInicial: '',
    dataRealizacaoFinal: '',
  }

  recebimentoFiltro: RecebimentoFiltro = { ...this.recebimentoFiltroDefault }

  recebimentos: Recebimento[] = []
  recebimentoItens: RecebimentoItens = {
    acoes: {},
    itens: [],
    logoHospital: '',
    valorTotal: 0,
  }

  profissionaisExecutantes: ProfissionalExecutante[] = []
  pacientes: RecebimentoPaciente[] = []
  procedimentos: NovoProcedimento[] = []
  pagina: number = 1
  totalPagina: number = 0
  recebimentoListItemEmpty: boolean = false
  valorTotalRecebimentoItems: number = 0

  @Mutation
  setModalTabelaPrestador(value: boolean) {
    this.modalTabelaPrestador = value
  }

  @Mutation
  setModalDadosNF(value: boolean) {
    this.modalDadosNF = value
  }

  @Mutation
  setNFSelected(value: any) {
    this.nfSelected = value
  }

  @Mutation
  setNumeroNota(value: string) {
    this.numeroNota = value
  }

  @Mutation
  setValorNotaFiscal(value: string) {
    this.valorNotaFiscal = value
  }

  @Mutation
  clearModalDadosNF() {
    this.numeroNota = ''
    this.valorNotaFiscal = ''
  }

  @Mutation
  setModalTabelaProfissional(value: boolean) {
    this.modalTabelaProfissional = value
  }

  @Mutation
  setModalTabelaOperadora(value: boolean) {
    this.modalTabelaOperadora = value
  }

  @Mutation
  setDadosContratoEGestores(value: any[]) {
    this.dadosContratoEGestores = value
  }

  @Mutation
  setFontePagadoraIdContrato(value: string) {
    this.fontePagadoraIdContrato = value
  }

  @Mutation
  setModalAddTabelaPrestador(value: boolean) {
    this.modalAddTabelaPrestador = value
  }

  @Mutation
  setModalAddTabelaProfissional(value: boolean) {
    this.modalAddTabelaProfissional = value
  }

  @Mutation
  setModalAddTabelaOperadora(value: boolean) {
    this.modalAddTabelaOperadora = value
  }

  @Mutation
  setTabelaPrestadores(value: any) {
    this.tabelaPrestadores = value
  }

  @Mutation
  setTabelaProfissionais(value: any) {
    this.tabelaProfissionais = value
  }

  @Mutation
  setTabelaProfissionaisById(value: any) {
    this.tabelaProfissionaisById = value
  }

  @Mutation
  setProfissionais(value: any) {
    this.profissionais = value
  }

  @Mutation
  setTabelaOperadoras(value: any) {
    this.tabelaOperadoras = value
  }

  @Mutation
  setPrestadoresRepasse(value: any[]) {
    this.prestadoresRepasse = value
  }

  @Mutation
  setPrestadores(value: any[]) {
    this.prestadores = value
  }

  @Mutation
  setSelectedPrestador(value: any) {
    this.selectedPrestador = value
  }

  @Mutation
  setSelectedProfissional(value: any) {
    this.selectedProfissional = value
  }

  @Mutation
  setTabelaPrecoId(value: any) {
    this.tabelaPrecoId = value
  }

  @Mutation
  setIdForLoadTabelaProfissionaisById(value: any) {
    this.idTabelaProfissionais = value
  }

  @Mutation
  setValorTotalRecebimentoItems(value: number) {
    this.valorTotalRecebimentoItems = value
  }

  @Mutation
  setAnoMesReferenciaDeSelected(value: string) {
    this.anoMesReferenciaDeSelected = value
  }

  @Mutation
  setGestorIdResponse(value: string) {
    this.gestorIdResponse = value
  }

  @Mutation
  setDadosAddGestor(value: any) {
    this.dadosAddGestor = value
  }

  @Mutation
  setContratoId(value: string) {
    this.contratoId = value
  }

  @Mutation
  setModalCadastroEmpresaMedicaResponsavel(value: boolean) {
    this.modalCadastroEmpresaMedicaResponsavel = value
  }

  @Mutation
  setModalGestores(value: boolean) {
    this.modalGestores = value
  }

  @Mutation
  setModalAddGestores(value: boolean) {
    this.modalAddGestores = value
  }

  @Mutation
  setContratoGestores(value: any) {
    this.contratoGestores = value
  }

  @Mutation
  setAnoMesReferenciaAteSelected(value: string) {
    this.anoMesReferenciaAteSelected = value
  }

  fontePagadora: FontePagadoraRecebimento = { fontePagadoraId: '', fontePagadoraNome: '' }
  fontePagadoras: any[] = []
  fontesPagadoras: FontePagadoraRecebimento[] = []
  relatorio: RelatorioRecebimento = { id: '', nome: '' }
  relatorios: RelatorioRecebimento[] = []
  podeEmitirRelatorio: boolean = false
  anoMesReferencia: string = moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DDTHH:mm:ss')

  @Mutation
  setFontePagadora(value: FontePagadoraRecebimento) {
    this.fontePagadora = value
  }

  @Mutation
  setFontePagadoras(data: any) {
    this.fontePagadoras = data
  }

  @Mutation
  setFontePagadoraSelected(value: any[]) {
    if (this.fontePagadoraSelected.includes(value)) {
      this.fontePagadoraSelected.splice(this.fontePagadoraSelected.indexOf(value), 1)
    } else {
      this.fontePagadoraSelected.push(value)
    }
  }

  @Mutation
  setAnoMesReferenciaSelected(value: string[]) {
    this.anoMesReferenciaSelected = value

    if (this.anoMesReferenciaSelected.length === 2) {
      const [dataInicio, dataFim] = this.anoMesReferenciaSelected

      this.dataInicio = dataInicio
      this.dataFim = dataFim
    } else {
      console.error('Array de datas deve conter exatamente duas datas.')
    }
  }

  @Mutation
  clearFiltroRecebimento() {
    this.fontePagadoraSelected = []
    this.anoMesReferenciaAteSelected = ''
    this.anoMesReferenciaDeSelected = ''
  }

  @Mutation
  setPodeEmitirRelatorio(value: boolean) {
    this.podeEmitirRelatorio = value
  }

  @Mutation
  clearFontePagadora() {
    this.fontePagadora = { fontePagadoraId: '', fontePagadoraNome: '' }
  }

  @Mutation
  setFontesPagadoras(value: FontePagadoraRecebimento[]) {
    this.fontesPagadoras = value
  }

  @Mutation
  clearFontesPagadoras() {
    this.fontesPagadoras = []
  }

  @Mutation
  setRelatorio(value: RelatorioRecebimento) {
    this.relatorio = value
  }

  @Mutation
  clearRelatorio() {
    this.relatorio = { id: '', nome: '' }
  }

  @Mutation
  setRelatorios(value: RelatorioRecebimento[]) {
    this.relatorios = value
  }

  @Mutation
  clearRelatorios() {
    this.relatorios = []
  }

  @Mutation
  setAnoMesReferencia(value: string) {
    this.anoMesReferencia = value
  }

  @Mutation
  clearAnoMesReferencia() {
    this.anoMesReferencia = moment().format('YYYY-MM-01T00:00:00')
  }

  @Mutation
  setRecebimentos(recebimentos: Recebimento[]) {
    this.recebimentos = recebimentos
  }

  @Mutation
  clearDocumento() {
    this.recebimento.nomeArquivoOriginal = ''
  }

  @Mutation
  setNomeArquivoOriginal(nome: string) {
    this.recebimento.nomeArquivoOriginal = nome
  }

  @Mutation
  setModalRecebimentoDetalhes(value: boolean) {
    this.modalRecebimento.detalhes = value
  }

  @Mutation
  setModalRecebimentoFiltro(value: boolean) {
    this.modalRecebimento.filtro = value
  }

  @Mutation
  setNumeroAtendimentoFiltro(value: string) {
    this.recebimentoFiltro.numeroAtendimento = value
  }

  @Mutation
  setRecebimento(value: Recebimento) {
    this.recebimento = value
  }

  @Mutation
  setValoresCalculados(value: any[]) {
    this.valoresCalculados = value
  }

  @Mutation
  setValorLiquido(value: any) {
    this.valorLiquido = value
  }

  @Mutation
  setRecebimentoItens(value: RecebimentoItens) {
    this.recebimentoItens.acoes = value.acoes
    this.recebimentoItens.valorTotal = value.valorTotal
    this.recebimentoItens.logoHospital = value.logoHospital || ''
    value.itens.map(i => this.recebimentoItens.itens.push(i))
    this.recebimentoListItemEmpty = this.recebimentoItens.itens.length === 0
  }

  @Mutation
  setRecebimentoListItemEmpty(value: boolean) {
    this.recebimentoListItemEmpty = value
  }

  @Mutation
  setProfissionaisExecutantes(value: ProfissionalExecutante[]) {
    this.profissionaisExecutantes = value
  }

  @Mutation
  setPacientes(value: RecebimentoPaciente[]) {
    this.pacientes = value
  }

  @Mutation
  setProcedimentos(value: NovoProcedimento[]) {
    this.procedimentos = value
    this.procedimentos.map((p) => {
      const item = p
      item.descricaoCompleta = `${item.codigo} - ${item.descricao}`
      return item
    })
  }

  @Mutation
  setPagina(value: number) {
    this.pagina = value
  }

  @Mutation
  setTotalPagina(value: number) {
    this.totalPagina = value
  }

  @Mutation
  setPeriodoInicio(inicio: string) {
    this.recebimentoFiltro.dataRealizacaoInicial = inicio
  }

  @Mutation
  setPeriodoFinal(final: string) {
    this.recebimentoFiltro.dataRealizacaoFinal = final
  }

  @Mutation
  setOperadoras(value: any) {
    this.operadorasList = value
  }

  @Mutation
  setSelectedOperadora(value: any) {
    this.selectedOperadora = value
  }

  @Mutation
  setCloseDisplay(recebimentoItem: RecebimentoItem) {
    for (let i = 0; i < this.recebimentoItens.itens.length; i++) {
      const element = this.recebimentoItens[i]
      if (element.paciente === recebimentoItem.paciente) {
        element.display = true
      } else {
        element.display = false
      }
    }
  }

  @Mutation
  clearRecebimento() {
    this.pagina = 1
    this.totalPagina = 0
    this.recebimento = { ...this.recebimentoDefault }
    this.recebimentoFiltro = { ...this.recebimentoFiltroDefault }
    this.procedimentos = []
    this.profissionaisExecutantes = []
    this.recebimentoItens.itens = []
    this.recebimentoItens.valorTotal = 0
  }

  @Mutation
  clearRecebimentoItens() {
    this.pagina = 1
    this.totalPagina = 0
    this.recebimentoItens.itens = []
    this.recebimentoItens.valorTotal = 0
  }

  @Mutation
  clearFilter() {
    this.recebimentoFiltro = { ...this.recebimentoFiltroDefault }
  }

  @Mutation
  setSituacaoRecebimento(value: string) {
    this.situacaoRecebimento = value
  }

  @Mutation
  clearExportarRegistros() {
    this.fontePagadora = { fontePagadoraId: '', fontePagadoraNome: '' }
    this.relatorio = { id: '', nome: '' }
    this.anoMesReferencia = moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DDTHH:mm:ss')
  }

  @Action
  async getFontePagadoraAll() {
    try {
      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getFontePagadoraAll()
      if (request.success) {
        this.context.commit('setFontesPagadoras', request.data as FontePagadoraRecebimento || [])
        this.context.commit('setFontePagadoras', request.data as FontePagadoraRecebimento || [])
      }
      return request
    } catch (error) {
      this.context.commit('setFontesPagadoras', [])
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getDadosContratoEGestores() {
    try {
      const request = await Apis.Legacy.RecebimentoApi.getDadosContratoEGestores()
      if (request.success) {
        this.context.commit('setDadosContratoEGestores', request.data)
      }
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getRelatoriosByFontePagadora() {
    try {
      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getRelatoriosByFontePagadora({ area: 'ExtratoPagamento' })
      if (request.success) this.context.commit('setRelatorios', request.data.itens as RelatorioRecebimento[] || [])
      return request
    } catch (error) {
      this.context.commit('setRelatorios', [])
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async generateRelatorioByFontePagadora() {
    try {
      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.generateRelatorioByFontePagadora({
        fontePagadoraId: this.fontePagadora.fontePagadoraId,
        relatorioId: this.relatorio.id,
        anoMesReferencia: this.anoMesReferencia,
      })
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getTabelaPrestadores(id: number) {
    try {
      const params: any = {
        tabelaPrecoId: id,
      }
      const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getTabelaPrestadores(params)
      if (response.success) {
        return this.context.commit('setTabelaPrestadores', response.data.itens)
      }
      return response
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async getTabelaProfissionais() {
    try {
      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getTabelaProfissionais()
      if (request.success) {
        this.context.commit('setTabelaProfissionais', request.data.itens)
      }
      return request
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async getTabelaProfissionaisById() {
    try {
      const params: any = {
        tabelaPrecoId: this.idTabelaProfissionais
      }
      const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getTabelaProfissionaisById(params)
      if (response.success) {
        this.context.commit('setTabelaProfissionaisById', response.data.itens)
      }
      return response
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async getProfissionais() {
    try {
      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getProfissionais()
      if (request.success) {
        this.context.commit('setProfissionais', request.data.pessoas)
      }
      return request
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async upsertTabelaProfissional() {
    try {
      const params: any = {
        tabelaPrecoId: this.tabelaPrecoId,
        profissionalId: this.selectedProfissional,
      }
      const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.postTabelaProfissional(params)
      return response
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async deleteTabelaProfissional(id: any) {
    try {
      const param: any = {
        id,
      }
      const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.deleteTabelaProfissional(param)
      return response
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async getTabelaOperadora(id: number) {
    try {
      const params: any = {
        tabelaPrecoId: id,
      }
      const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getTabelaOperadora(params)
      if (response.success) {
        return this.context.commit('setTabelaOperadoras', response.data.itens)
      }
      return response
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async getPrestadoresRepasse() {
    try {
      const request = await Apis.Contrato.ContratoApi.getAllPrestadores()
      this.context.commit('setPrestadoresRepasse', request.success ? request.data : [])
      return request
    } catch (error) {
      this.context.commit('setPrestadoresRepasse', [])
      return { success: false, message: 'Ocorreu um erro na requisição' }
    }
  }

  @Action
  async getPrestadores() {
    try {
      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getPrestadores()
      if (request.success) {
        this.context.commit('setPrestadores', request.data.prestadores)
      }
      return request
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async upsertTabelaPrestadores() {
    try {
      const params: any = {
        tabelaPrecoId: this.tabelaPrecoId,
        prestadorId: this.selectedPrestador,
      }
      const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.upsertTabelaPrestadores(params)
      return response
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async postTabelaOperadora() {
    try {
      const params: any = {
        operadoraId: this.selectedOperadora,
        tabelaPrecoId: this.tabelaPrecoId,
      }
      const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.postTabelaOperadora(params)
      return response
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async getOperadoras() {
    try {
      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getConvenio()
      if (request.success) {
        this.context.commit('setOperadoras', request.data.convenios)
      }
      return request
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async deleteTabelaPrestador(id: any) {
    try {
      const param: any = {
        id,
      }
      const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.deleteTabelaPrestador(param)
      return response
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async deleteTabelaOperadora(id: any) {
    try {
      const param: any = {
        id,
      }
      const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.deleteTabelaOperadora(param)
      return response
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async removeContratoGestor(id: string) {
    try {
      const params: any = {
        contratoId: this.contratoId,
        gestorId: id,
      }
      const response = await Apis.Contrato.ContratoApi.removeContratoGestor(params)
      return response
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async checkCpfGestor() {
    try {
      const request = await Apis.Cadastro.CadastroApi.checkCpfRemuneracao(this.dadosAddGestor.cpf)
      if (request.success) this.context.commit('setGestorIdResponse', request.data.id)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição. - CHECK_CPF_REMUNERACAO' }
    }
  }

  @Action
  async fluxoSemCpf() {
    const params: any = {
      nome: this.dadosAddGestor.nome,
      email: this.dadosAddGestor.email,
      cpf: this.dadosAddGestor.cpf,
    }

    try {
      const response = await Apis.Cadastro.CadastroApi.upsertPessoaRemuneracao(params)
      if (response.success) this.context.commit('setGestorIdResponse', response.data)
      return response
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição. - UPSERT_PESSOA_REMUNERACAO' }
    }
  }

  @Action
  async addGestor() {
    const params: any = [this.gestorIdResponse]
    try {
      const response = await Apis.Contrato.ContratoApi.addGestor(this.contratoId, params)
      return response
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição. - ADD_GESTOR' }
    }
  }

  @Action
  async envioAutenticacao() {
    const params: any = {
      id: this.gestorIdResponse,
      email: this.dadosAddGestor.email,
      name: this.dadosAddGestor.nome,
      hospitalId: this.fontePagadoraIdContrato,
      perfil: 'ExtratoPagamento',
    }
    try {
      const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.criarUsuario(params)
      if (response.success) this.setModalGestores(false); this.setModalAddGestores(false)
      return response
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição. - ENVIO_AUTENTICACAO' }
    }
  }

  @Action
  async download(params: any) {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.download(params)
    return response
  }

  @Action
  async deletarDocumentoPrestadorRecebimento(params: any) {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.deletarDocumentoPrestadorRecebimento(params)
    return response
  }

  @Action
  async deletarDocumento(params: any) {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.deletarDocumento(params)
    return response
  }

  @Action
  async uploadNotaFiscal(params: any) {
    try {
      const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.uploadNotaFiscal(params)
      return response
    } catch (error) {
      return { success: false }
    }
  }

  @Action({ commit: 'setRecebimentos' })
  async loadRecebimentos() {
    const params: any = {
      situacao: this.situacaoRecebimento,
      fontePagadoraIds: this.fontePagadoraSelected,
      dataFim: this.anoMesReferenciaAteSelected ? `${this.anoMesReferenciaAteSelected}-01` : '',
      dataInicio: this.anoMesReferenciaDeSelected ? `${this.anoMesReferenciaDeSelected}-01` : '',
    }
    const request = await Apis.Legacy.RecebimentoApi.loadRecebimentos(params)
    if (request.success) {
      return request.data
    }

    return []
  }

  @Action
  async recebimentoAcoes() {
    try {
      const response = await Apis.Legacy.RecebimentoApi.recebimentoAcoes()
      if (response.success) {
        this.context.commit('setPodeEmitirRelatorio', response.data.acoes.AppExibirGerarRelatorioRepasses)
      }
      return response
    } catch (error) {
      return { success: false }
    }
  }

  @Action({ commit: 'setRecebimentoItens' })
  async loadRecebimentoItens() {
    this.context.commit('setRecebimentoListItemEmpty', false)
    const filtro = this.recebimentoFiltro
    filtro.pagina = this.pagina
    filtro.contratoId = this.recebimento.contratoId
    filtro.prestadorRecebimentoId = this.recebimento.id

    const request = await Apis.Legacy.RecebimentoApi.loadRecebimentoItens(filtro)

    return request.success ? request.data : []
  }

  @Action({ commit: 'setProfissionaisExecutantes' })
  async loadProfissionaisExecutantes() {
    const prestadorRecebimentoId = this.recebimento.id
    const { contratoId } = this.recebimento

    const request = await Apis.Legacy
      .RecebimentoApi.loadProfissionaisExecutantes(prestadorRecebimentoId, contratoId)

    if (request.success) {
      return request.data
    }

    return []
  }

  @Action({ commit: 'setPacientes' })
  async loadPacientes() {
    const prestadorRecebimentoId = this.recebimento.id
    const { contratoId } = this.recebimento

    const request = await Apis.Legacy
      .RecebimentoApi.loadPacientes(prestadorRecebimentoId, contratoId)

    if (request.success) {
      return request.data
    }

    return []
  }

  @Action({ commit: 'setProcedimentos' })
  async loadProcedimentos() {
    const prestadorRecebimentoId = this.recebimento.id
    const { contratoId } = this.recebimento

    const request = await Apis.Legacy
      .RecebimentoApi.loadProcedimentos(prestadorRecebimentoId, contratoId)

    if (request.success) {
      return request.data
    }

    return []
  }

  @Action
  async exportarExcel() {
    const prestadorRecebimentoId = this.recebimento.id

    const request = await Apis.Legacy
      .RecebimentoApi.exportarExcel(prestadorRecebimentoId)
    return request
  }

  @Action
  async getValoresCalculados(id: string) {
    try {
      const request = await Apis.Legacy.RecebimentoApi.getValoresCalculados(id)
      this.context.commit('setValoresCalculados', request.data.itens)
      this.context.commit('setValorLiquido', request.data.valorLiquido)
      return request
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async getFontePagadoraLoggedUser() {
    const response = await Apis.Legacy.RecebimentoApi.getFontePagadoraLoggedUser()
    if (response.success) {
      this.context.commit('setFontePagadoras', response.data)
    }

    return response
  }

  @Action
  async getRelatoriosByFontePagadoraBackoffice() {
    try {
      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getRelatoriosByFontePagadora({ area: 'Financeiro' })
      if (request.success) this.context.commit('setRelatorios', request.data.itens as RelatorioRecebimento[] || [])
      return request
    } catch (error) {
      this.context.commit('setRelatorios', [])
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }
}
